// extracted by mini-css-extract-plugin
export default {"JPtitle":"JourneyPlanner_JPtitle__epxcR"};